import { Schema } from '@tunasong/icons'
import type { SvgIconComponent } from '@tunasong/icons'
import { logger } from '@tunasong/models'
import type { Command, DefaultGlobalContext, GenerateEntityCommand } from '@tunasong/plugin-lib'
import { generateRiderFromProfiles } from '@tunasong/plugin-rider'
import { profilesApi } from '@tunasong/redux'
import type { BandSpace, Persisted, Rider } from '@tunasong/schemas'
import { isBandSpace, isPersisted } from '@tunasong/schemas'

/**
 * Get member user IDs from entity ACLs and owner
 */
function getMemberIds(entity: Persisted<BandSpace>): string[] {
  const ids = new Set<string>()
  ids.add(entity.userId)
  for (const acl of entity.acls ?? []) {
    if (typeof acl.principal === 'string' && !['PUBLIC', 'AUTHENTICATED'].includes(acl.principal)) {
      ids.add(acl.principal)
    }
  }
  return Array.from(ids)
}

export const generateRiderCommand = ({
  entity,
  globalContext: { graph, dispatch },
}: GenerateEntityCommand<DefaultGlobalContext>): Command[] => {
  if (!entity || !isBandSpace(entity) || !isPersisted(entity)) {
    return []
  }

  const bandspace = entity as Persisted<BandSpace>

  return [
    {
      id: 'bandspace.generate-rider',
      name: 'Generate Technical Rider',
      Icon: Schema as SvgIconComponent,
      color: 'deepOrange',

      cmd: async () => {
        // Fetch member profiles using Redux dispatch
        const memberIds = getMemberIds(bandspace)
        logger.info('Fetching member profiles', { bandspace: bandspace.id, memberIds })

        // Dispatch the loadProfiles query and await the result
        const result = await dispatch(profilesApi.endpoints.loadProfiles.initiate({ userIds: memberIds }))
        const profiles = result.data ?? []

        logger.info('Generating rider from profiles', { bandspace: bandspace.id, memberCount: profiles.length })

        const riderDraft = generateRiderFromProfiles(bandspace, profiles) as Rider

        const rider = await graph.createEntity({
          entity: riderDraft,
          parent: bandspace,
        })

        logger.info('Created rider', { riderId: rider.id })
      },
    },
  ]
}
